import { IconButton } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import Print from '@mui/icons-material/Print';
import axiosInstance from '../../app/axiosInstance';
import { useOrgaoRoutes } from '../../config/useOrgaoRoutes';
import { Documento } from '../../types/processo/Documento';

interface PrintFullContentButtonProps {
  conteudoTexto: string; // Conteúdo do documento
  documento: Documento; // Dados do documento para gerar o cabeçalho
}

const PrintFullContentButton: React.FC<PrintFullContentButtonProps> = ({ conteudoTexto, documento }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const url = useRef('');

  // Função que será chamada quando a imagem for carregada
  const handleImageLoaded = (url: string) => {
    setImageUrl(url);
  };

  //const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const orgaoRoutes = useOrgaoRoutes();
  const API_URL = orgaoRoutes.ORGAO_API_EP;

  // Função para carregar a imagem de forma protegida
  const fetchImage = async (filename: string) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`${API_URL}/anexo?filename=${filename}`, {
        responseType: 'blob' // Informamos que esperamos um Blob de imagem
      });

      const imageBlob = response.data; // Obtém o conteúdo da imagem
      const imageObjectUrl = URL.createObjectURL(imageBlob); // Cria uma URL temporária
      setImageUrl(imageObjectUrl); // Atualiza o estado com a URL da imagem
      //       url.current = imageObjectUrl;

      // onImageLoaded && onImageLoaded(imageObjectUrl); // Passa a URL gerada para o pai
    } catch (err) {
      console.error('Erro ao carregar a imagem:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (documento.orgao?.logo) {
      fetchImage(documento.orgao?.logo); // Faz a requisição da imagem assim que o componente for montado
    }
  }, [documento.orgao?.logo]);

  const handlePrint = () => {
    if (!conteudoTexto || !imageUrl) return; // Não imprime sem imagem ou conteúdo

    // Gerar o HTML completo para impressão
    const cabecalhoHTML1 = `
      <div style="display: flex; flex-direction: column; text-align: center; padding: 20px; background-color: #e8e2e2; margin-bottom: 20px;">
        <div style="display: flex; justify-content: center; margin-bottom: 20px;">
          <!-- Logo -->
          <img src="${url.current}" alt="Logo do órgão" style="width: 70px; height: auto; object-fit: contain;" />
        </div>

        <!-- Informações do Cabeçalho -->
        <h2 style="margin: 0; font-size: 24px;">${documento.orgao?.nome}</h2>
        <h3 style="margin: 0; font-size: 20px;">${documento.setor?.secretaria?.nome}</h3>
        <h4 style="margin: 0; font-size: 18px;">${documento.setor?.nome}</h4>

        <!-- Endereço -->
        <p style="font-size: 14px; margin: 5px 0;">Endereço: ${documento.setor?.endereco}, ${documento.setor?.numero}, ${documento.setor?.bairro}, ${documento.setor?.cidade} - CEP: ${
      documento.setor?.cep
    }</p>
        
        <!-- Telefone -->
        <p style="font-size: 14px; margin: 5px 0;">Telefone: ${documento.setor?.telefone || 'Não disponível'}</p>
      </div>
    `;

    const cabecalhoHTML = `
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; padding: 20px; background-color: #e8e2e2; margin-bottom: 20px;">
    <!-- Logo -->
    <div style="flex-shrink: 0; margin-right: 20px;">
      <img src="${imageUrl}" alt="Logo do órgão" style="width: 150px; height: auto; object-fit: contain;" />
    </div>

    <!-- Informações do Cabeçalho -->
    <div style="flex-grow: 1;">
      <h2 style="margin: 0; font-size: 24px;">${documento.orgao?.nome}</h2>
      <h3 style="margin: 0; font-size: 20px;">${documento.setor?.secretaria?.nome}</h3>
      <h4 style="margin: 0; font-size: 18px;">${documento.setor?.nome}</h4>

      <!-- Endereço -->
      <p style="font-size: 14px; margin: 5px 0;">Endereço: ${documento.setor?.endereco}, ${documento.setor?.numero}, ${documento.setor?.bairro}, ${documento.setor?.cidade} - CEP: ${
      documento.setor?.cep
    }</p>
      
      <!-- Telefone -->
      <p style="font-size: 14px; margin: 5px 0;">Telefone: ${documento.setor?.telefone || 'Não disponível'}</p>
    </div>
  </div>
`;

    // Gerando o HTML completo para impressão
    const printWindow = window.open('', '', 'height=600,width=800');
    if (!printWindow) return;

    // Passando o HTML de impressão para a nova janela
    printWindow.document.write(`
      <html>
        <head>
          <title>Impressão do Documento</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
            h2, h3, h4, p { margin: 5px 0; }
            .content { padding: 20px; }
            img { width: 150px; height: auto; object-fit: contain; }
          </style>
        </head>
        <body>
          <div class="content">
            ${cabecalhoHTML}  <!-- Cabeçalho -->
            <div style="font-size: 1.0rem; text-align: justify; padding: 10px;">
              ${documento.conteudo}  <!-- Conteúdo do documento -->
            </div>
          </div>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <div>
      {/* Passando a função para carregar a imagem e o filename       
      <ProtectedImage filename={documento.orgao?.logo || ''} onImageLoaded={handleImageLoaded} hideImage={true}/>
      */}

      <IconButton color="secondary" size="large" onClick={handlePrint}>
        <Print />
      </IconButton>
    </div>
  );
};

export default PrintFullContentButton;
